
/**
 * Truncates a given text to a specified length and appends a replacement string if truncated.
 *
 * @param {string} input - The text to be truncated.
 * @param {number} length - The maximum length of the truncated text.
 * @param {string} [replacement='...'] - The string to append to the truncated text.
 * @returns {string} - The truncated text with the replacement string appended if truncated.
 */
const truncateText = (input, length, replacement = '...') => {
  if (input == null) return '';
  const text = String(input);
  if (text.length <= length) return text;
  return text.slice(0, length) + replacement;
};

export default truncateText;
